import {getFormMessages, getTicketHolderFormId} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React, {useRef} from 'react'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {getExpandedTicketIndex, getIndividualReservationTickets} from '../../../selectors/checkout'
import {getEvent} from '../../../selectors/event'
import {FormSubmitButton} from '../../form-submit-button'
import {ExpandedFormHandle, TicketsDetailsProps} from './interfaces'
import {TicketDetails} from './ticket-details'
import s from './ticket-details.scss'

export const TicketsDetails = ({editing, onSubmit}: TicketsDetailsProps) => {
  const {setExpandedTicketIndex, setTicketDetails} = useAppActions()

  const expandedTicketIndex = useAppSelector(getExpandedTicketIndex)
  const individualTickets = useAppSelector(getIndividualReservationTickets)
  const formHandles = useRef<ExpandedFormHandle[]>(Array(individualTickets.length).fill(null))
  const event = useAppSelector(getEvent)
  const messages = getFormMessages(event)
  const wixFormId = getTicketHolderFormId(event)

  const toggleExpandedTicket = (index: number) => {
    setExpandedTicketIndex(expandedTicketIndex === index ? -1 : index)
  }

  const registerFormHandle = (index: number, ref: ExpandedFormHandle) => {
    formHandles.current[index] = ref
  }

  const submit = async () => {
    const validity = await Promise.all(formHandles.current.map(ref => ref?.validate()))
    const invalidIndex = validity.findIndex(value => !value)

    if (invalidIndex !== -1) {
      setExpandedTicketIndex(invalidIndex)
    } else {
      formHandles.current.forEach((ref, index) => {
        setTicketDetails({index, details: ref.getValues(), valid: true})
      })

      setExpandedTicketIndex(-1)
      onSubmit()
    }
  }

  return (
    <div className={s.container}>
      {individualTickets.map((individualTicket, index) => (
        <TicketDetails
          key={index}
          index={index}
          formId={wixFormId}
          individualTicket={individualTicket}
          editable={editing}
          expanded={index === expandedTicketIndex}
          lastTicket={index === individualTickets.length - 1}
          onExpand={() => toggleExpandedTicket(index)}
          onRegisterFormHandle={ref => registerFormHandle(index, ref)}
        />
      ))}
      {editing && (
        <div className={s.button}>
          <FormSubmitButton
            dataHook={DH.FORM_BUTTON}
            text={messages.checkout.submitActionLabel || messages.rsvp.submitActionLabel}
            onClick={submit}
          />
        </div>
      )}
    </div>
  )
}
